import { Pagination } from '@mui/material'
import classNames from 'classnames'

import { get } from 'lodash'
import { useCallback, useEffect, useState } from 'react'

import { BsPlus } from 'react-icons/bs'

import { useSelector } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'
import CreatedByYou from '../../components/Billing/CreatedByYou'
import PaidForYou from '../../components/Billing/PaidForYou'
import ToApprove from '../../components/Billing/ToApprove'
import Loading from '../../components/Loading'
import api, { operation } from '../../services/axios'
import { StoreState } from '../../store'
import {
    Container,
    PaginationContainer,
    PaymentLinks,
    HeaderPaymentLinks,
    Title,
    Content,
} from './styles'

const LinkGerenciar: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [searchParams] = useSearchParams()
    const [isLoading, setIsLoading] = useState(false)

    const [myPaymentLinks, setMyPaymentLinks] = useState([])
    // const [loadingMyLinks, setLoadingMyLinks] = useState(false)
    const [myLinksCount, setMyLinksCount] = useState(0)
    const [myLinksPage, setMyLinksPage] = useState(1)
    // -------------------------
    const [paidPaymentLinks, setPaidPaymentLinks] = useState([])
    // const [loadingPaidLinks, setLoadingPiadLinks] = useState(false)
    const [paidLinksCount, setPaidLinksCount] = useState(0)
    const [paidLinksPage, setPaidLinksPage] = useState(1)

    //---------------------
    const [approveLinks, setApproveLinks] = useState([])
    const [approveLinksPage, setApproveLinksPage] = useState(1)
    const [approveLinksCount, setApproveLinksCount] = useState(0)
    // const [loadingApproveLinks, setLoadingApproveLinks] = useState(false)
    //---------------------

    const [createdByYou, setCreatedByYou] = useState(true)
    const [paidForYou, setPaidForYou] = useState(false)
    const [toApprove, setToApprove] = useState(false)

    //------------
    const [toApproveNotification, setToApproveNotification] = useState(0)

    const getMyPaymentsLinks = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                if (createdByYou) {
                    const { data } = await api.get(
                        `/link/gerenciar/meus-links/${cnpj_cpf}/${myLinksPage}`
                    )
                    setMyPaymentLinks(data.paymentsLinks)
                    setMyLinksCount(data.paymentsLinksCount)
                }
                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf, myLinksPage, createdByYou])

    const getPaidPaymentsLinks = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                if (paidForYou) {
                    const { data } = await api.get(
                        `/link/gerenciar/paid-links/${cnpj_cpf}/${paidLinksPage}`
                    )
                    setPaidPaymentLinks(data.paymentsLinks)
                    setPaidLinksCount(data.paymentsLinksCount)
                }
                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf, paidLinksPage, paidForYou])

    const getApproveLinks = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                if (toApprove) {
                    const { data } = await api.get(
                        `/link/aprovar/${cnpj_cpf}/${approveLinksPage}`
                    )
                    setApproveLinks(data.paymentsLinksToApprove)
                    setApproveLinksCount(data.paymentsLinksToApproveCount)
                }
                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf, approveLinksPage, toApprove])

    useEffect(() => {
        getMyPaymentsLinks()
    }, [getMyPaymentsLinks])

    useEffect(() => {
        getPaidPaymentsLinks()
    }, [getPaidPaymentsLinks])

    useEffect(() => {
        getApproveLinks()
    }, [getApproveLinks])

    useEffect(() => {
        if (searchParams.get('a')) {
            setCreatedByYou(false)
            setPaidForYou(false)
            setToApprove(true)
        }
        if (searchParams.get('m')) {
            setCreatedByYou(true)
            setPaidForYou(false)
            setToApprove(false)
        }

        if (searchParams.get('p')) {
            setCreatedByYou(false)
            setPaidForYou(true)
            setToApprove(false)
        }
    }, [searchParams])

    useEffect(() => {
        api.get(`/cobrancas/notificacoes/${cnpj_cpf}`)
            .then(({ data }) => {
                setToApproveNotification(data.toApproveNotification)
            })
            .catch(() => {})
    }, [cnpj_cpf])

    return (
        <Container>
            <HeaderPaymentLinks>
                {/* <h2>Cobranças criadas por mim</h2> */}
                <ul>
                    <li
                        className={classNames({
                            'active ': createdByYou,
                        })}
                    >
                        <button
                            onClick={() => {
                                setCreatedByYou(true)
                                setPaidForYou(false)
                                setToApprove(false)
                            }}
                        >
                            Criadas por você
                        </button>
                    </li>
                    <li
                        className={classNames({
                            'active ': paidForYou,
                        })}
                    >
                        <button
                            onClick={() => {
                                setCreatedByYou(false)
                                setPaidForYou(true)
                                setToApprove(false)
                            }}
                        >
                            Pagas por você
                        </button>
                    </li>
                    <li
                        className={classNames({
                            'active ': toApprove,
                        })}
                    >
                        <button
                            onClick={() => {
                                setCreatedByYou(false)
                                setPaidForYou(false)
                                setToApprove(true)
                            }}
                        >
                            Aprovar{' '}
                            <span className="to-approve-notification">
                                {toApproveNotification}
                            </span>
                        </button>
                    </li>
                </ul>
            </HeaderPaymentLinks>
            <Content>
                <Title>
                    {/* <h1>Cobranças</h1> */}
                    <Link to="/cobranca/criar">
                        <button className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md ">
                            {/* <BiLink size={22} /> */}
                            {/* <AiOutlinePlus size={20} /> */}
                            {/* <HiOutlinePlus size={22} /> */}
                            <BsPlus size={24} />
                            Criar cobrança
                        </button>
                    </Link>
                </Title>
                <PaymentLinks className="">
                    {isLoading ? (
                        <Loading />
                    ) : (
                        <>
                            {createdByYou && (
                                <CreatedByYou
                                    getMyPaymentsLinks={getMyPaymentsLinks}
                                    myPaymentLinks={myPaymentLinks}
                                />
                            )}
                            {paidForYou && (
                                <PaidForYou
                                    paidPaymentLinks={paidPaymentLinks}
                                />
                            )}
                            {toApprove && (
                                <ToApprove approveLinks={approveLinks} />
                            )}
                        </>
                    )}
                </PaymentLinks>
                <PaginationContainer>
                    {createdByYou && (
                        <Pagination
                            onChange={(e, value) => setMyLinksPage(value)}
                            page={myLinksPage}
                            count={myLinksCount}
                            color="primary"
                            variant="outlined"
                            shape="rounded"
                        />
                    )}
                    {paidForYou && (
                        <Pagination
                            onChange={(e, value) => setPaidLinksPage(value)}
                            page={paidLinksPage}
                            count={paidLinksCount}
                            color="primary"
                            variant="outlined"
                            shape="rounded"
                        />
                    )}
                    {toApprove && (
                        <Pagination
                            onChange={(e, value) => setApproveLinksPage(value)}
                            page={approveLinksPage}
                            count={approveLinksCount}
                            color="primary"
                            variant="outlined"
                            shape="rounded"
                        />
                    )}
                </PaginationContainer>
            </Content>
        </Container>
    )
}

export default LinkGerenciar
